import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useParams } from "react-router-dom";
import {
  timetableColumns,
  timetableRows,
  fetchTimetableRows,
} from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { useNavigate } from "react-router-dom";

const TimeTableDataTable = () => {
  const [data, setData] = useState(timetableRows);
  const [loading, setLoading] = useState(false);
  const [classLoading, setClassLoading] = useState(false);
  const { slugs } = useSlug();
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [roles, setRoles] = useState([]);
  const { timeTableMasterId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Get roles from localStorage and split into array
    const roleString = localStorage.getItem("role_name") || "";
    const rolesArray = roleString.split(",").map((role) => role.trim());
    setRoles(rolesArray);

    const getData = async () => {
      setLoading(true);
      const rows = await fetchTimetableRows(timeTableMasterId);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();

    // Fetch classes if user has Admin role
    if (rolesArray.includes("Admin") || rolesArray.includes("Super Admin")) {
      fetchClassDropdown();
    }
  }, []);

  const fetchClassDropdown = async () => {
    try {
      setClassLoading(true);
      const center_id = localStorage.getItem("center_id");
      if (!center_id) {
        toast.error("Center ID not found in local storage");
        return;
      }

      const response = await fetch(
        `${serverUrl}/result_dashboard/class_dropdown?centerId=${center_id}`,
      );
      if (!response.ok) {
        throw new Error("Failed to fetch class dropdown");
      }
      const data = await response.json();
      console.log("API Response:", data);
      setClasses(data.data);

      // Set default selected class if available
      if (data.length > 0) {
        const storedClassId = localStorage.getItem("Aclass_id");
        const initialClass =
          storedClassId && data.find((c) => c.id === storedClassId)
            ? storedClassId
            : data[0].id;
        setSelectedClass(initialClass);
        localStorage.setItem("Aclass_id", initialClass);
      }
    } catch (error) {
      console.error("Error fetching class dropdown:", error);
      toast.error("Failed to fetch class options");
    } finally {
      setClassLoading(false);
    }
  };

  const handleClassChange = (event) => {
    const classId = event.target.value;
    setSelectedClass(classId);
    localStorage.setItem("Aclass_id", classId);
  };

  const handleDelete = (id) => {
    fetch(`${serverUrl}/del_timetable/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete slot");
        }
        setData(data.filter((item) => item.id !== id));
        toast.success("Slot deleted successfully!");
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const handleStudentDownload = async () => {
    const center_id = localStorage.getItem("center_id");
    const class_id = localStorage.getItem("Aclass_id");

    if (!center_id || !class_id) {
      toast.error("Center ID or Class ID not found in local storage");
      return;
    }

    const downloadUrl = `${serverUrl}/download-timetable-without?center_id=${center_id}&class_id=${class_id}`;

    const triggerDownload = (url, filename) => {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.download = filename || "student-timetable.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    triggerDownload(downloadUrl, "student-timetable.pdf");
  };

  const handleAdminDownload = async () => {
    const center_id = localStorage.getItem("center_id");
    const class_id = localStorage.getItem("Aclass_id");

    if (!center_id || !class_id) {
      toast.error("Center ID or Class ID not found in local storage");
      return;
    }

    const downloadUrl = `${serverUrl}/download-timetable?center_id=${center_id}&class_id=${class_id}`;

    const triggerDownload = (url, filename) => {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.download = filename || "admin-timetable.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    triggerDownload(downloadUrl, "admin-timetable.pdf");
  };

  const viewLinkString = "Timetable-Single";
  const editLinkString = "Timetable-Edit";
  const newLinkString = "Timetable-New";
  const newLinkString_1 = "Teacherattendance-New";
  const newLinkString_2 = "Downloadtimetable";
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 300,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(newLinkString_1) && (
              <Link
                to={`/teacher-attendance/new/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">Attendance</div>
              </Link>
            )}
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/time-table/time-table-slot/${timeTableMasterId}/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/time-table/time-table-slot/${timeTableMasterId}/update-time-table/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3">
          {/* Title */}
          <h2 className="title text-gray-700 text-2xl">Timetable Slots</h2>

          {/* Controls */}
          <div className="flex flex-col sm:flex-row flex-wrap gap-2 w-full lg:w-auto items-center">
            {/* 

            {(roles.includes("Admin") || roles.includes("Super Admin")) && (
              // <FormControl
              //   size="small"
              //   className="classDropdown w-full sm:w-auto"
              //   sx={{ minWidth: 180 }}
              // >
              //   <InputLabel id="class-select-label">Select Class</InputLabel>
              //   <Select
              //     labelId="class-select-label"
              //     value={selectedClass}
              //     label="Select Class"
              //     onChange={handleClassChange}
              //     disabled={classLoading}
              //   >
              //     {classLoading ? (
              //       <MenuItem value="">Loading classes...</MenuItem>
              //     ) : classes.length > 0 ? (
              //       classes.map((classItem) => (
              //         <MenuItem key={classItem.id} value={classItem.id}>
              //           {classItem.name}
              //         </MenuItem>
              //       ))
              //     ) : (
              //       <MenuItem value="">No classes available</MenuItem>
              //     )}
              //   </Select>
              // </FormControl>
              <FormControl
                size="small"
                className="classDropdown w-full sm:w-auto"
                sx={{
                  minWidth: 180,
                  height: 32,
                  "& .MuiOutlinedInput-root": {
                    height: 32,
                    borderRadius: "5px",
                    border: "1px solid green",
                    backgroundColor: "transparent",
                    color: "green",
                    fontSize: "16px",
                    fontWeight: 500,
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "green",
                      color: "white",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "green",
                    },
                  },
                  "& .MuiSelect-icon": {
                    color: "green",
                  },
                  "& .MuiMenuItem-root": {
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "green",
                    textAlign: "center",
                  },
                }}
              >
                <Select
                  value={selectedClass}
                  onChange={handleClassChange}
                  disabled={classLoading}
                  displayEmpty
                >
                  <MenuItem value="" sx={{ fontSize: "16px", fontWeight: 500, color: "green", textAlign: "center" }}>
                    Select Class
                  </MenuItem>
                  {classLoading ? (
                    <MenuItem value="" sx={{ fontSize: "16px", fontWeight: 500, color: "green", textAlign: "center" }}>
                      Loading classes...
                    </MenuItem>
                  ) : classes.length > 0 ? (
                    classes.map((classItem) => (
                      <MenuItem
                        key={classItem.id}
                        value={classItem.id}
                        sx={{ fontSize: "16px", fontWeight: 500, color: "green", textAlign: "center" }}
                      >
                        {classItem.name}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem value="" sx={{ fontSize: "16px", fontWeight: 500, color: "green", textAlign: "center" }}>
                      No classes available
                    </MenuItem>
                  )}
                </Select>
              </FormControl>

              // <FormControl
              //   size="small"
              //   className="classDropdown w-full sm:w-auto"
              //   sx={{
              //     minWidth: 180,
              //     height: 32,
              //     "& .MuiOutlinedInput-root": {
              //       height: 32,
              //       borderRadius: "5px",
              //       border: "1px solid green",
              //       backgroundColor: "transparent",
              //       color: "green",
              //       fontSize: "16px",
              //       fontWeight: 500,
              //       textAlign: "center",
              //       display: "flex",
              //       alignItems: "center",
              //       justifyContent: "center",
              //       transition: "all 0.3s ease",
              //       "&:hover": {
              //         backgroundColor: "green",
              //         color: "white",
              //       },
              //       "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              //         borderColor: "green",
              //       },
              //     },
              //     "& .MuiSelect-icon": {
              //       color: "green",
              //     },
              //     "& .MuiMenuItem-root": {
              //       fontSize: "16px",
              //       fontWeight: 500,
              //     },
              //   }}
              // >
              //   <Select
              //     value={selectedClass}
              //     onChange={handleClassChange}
              //     disabled={classLoading}
              //     displayEmpty
              //   >
              //     <MenuItem value="">
              //       <em>Select Class</em>
              //     </MenuItem>
              //     {classLoading ? (
              //       <MenuItem value="">Loading classes...</MenuItem>
              //     ) : classes.length > 0 ? (
              //       classes.map((classItem) => (
              //         <MenuItem key={classItem.id} value={classItem.id}>
              //           {classItem.name}
              //         </MenuItem>
              //       ))
              //     ) : (
              //       <MenuItem value="">No classes available</MenuItem>
              //     )}
              //   </Select>
              // </FormControl>
            )}

            {slugs && slugs.includes(newLinkString_2) && (
              <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <button onClick={handleStudentDownload} className="commonButton w-full sm:w-auto">
                  Notice-Board Timetable
                </button>
                <button onClick={handleAdminDownload} className="commonButton w-full sm:w-auto">
                  Admin Timetable
                </button>
              </div>
            )} */}

            {slugs && slugs.includes(newLinkString) && (
              <Link
                to={`/time-table/time-table-slot/${timeTableMasterId}/new`}
                className="commonButton w-full sm:w-auto"
              >
                Add New
              </Link>
            )}
            <Link to="/time-table" className="commonButton w-full sm:w-auto">
              Back
            </Link>
          </div>
        </div>
      </div>

      {loading ? (
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={timetableColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar,
          }}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default TimeTableDataTable;
